import { Component, OnInit, Input } from '@angular/core';
import { DomainBrandService } from '@services/domain-brand.service';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  @Input() data: any;
  readonly year = new Date().getFullYear();

  constructor(public brand: DomainBrandService) {}

  ngOnInit(): void {}
}
